export const CONTAINER_NOT_FOUND_ERROR = 'Container Not Found!';
export const UNKNOWN_ERROR = 'Unknown Error Occurred.';
export const INVALID_PRINTER_IP = 'Invalid Printer IP!';
export const CONTAINERIZATION_ERROR = 'Could not Containerize!';
export const CONTAINER_ALREADY_SCANNED_ERROR = 'Container already scanned!';
export const INIT_ERROR = 'Failed to load init data';
export const GET_SORT_TYPES_ERROR = 'Unable to fetch Sort Types';
export const CREATE_BARCODE_LABEL_ERROR = 'Could not retrieve label data. Please try again.';
export const WIRELESS_PRINT_FAILED = 'Wireless print failed: ';
export const WIRELESS_PRINT_TIMEOUT = 'Print timed out. Check printer connection.';
export const WIRELESS_PRINT_IN_PROGRESS = 'A print job is already in progress. Please wait.';
export const INVENTORY_MOVE_PARTIAL_FAILURE = 'failed to move';